module.exports = __webpack_public_path__ + "components/app-store/static/s7-cf5af9c5dc2d3ea98f5e16e6337a018c.jpg";